import { render, staticRenderFns } from "./shenbaoAdd.vue?vue&type=template&id=f16405be&scoped=true&"
import script from "./shenbaoAdd.vue?vue&type=script&lang=js&"
export * from "./shenbaoAdd.vue?vue&type=script&lang=js&"
import style0 from "./shenbaoAdd.vue?vue&type=style&index=0&id=f16405be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16405be",
  null
  
)

export default component.exports